<template>
    <div>
        <nav>

            <v-app-bar color="indigo" dark fixed app>
                <v-app-bar-nav-icon class="grey--text" @click="drawer = !drawer"></v-app-bar-nav-icon>
                <v-toolbar-title class="text-uppercase grey--text">
                    <span class="font-weight-light">UPDATE Masterfiles</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>


                <v-btn text color="grey"
                    @click.prevent="refresh()">
                    <v-icon right>refresh</v-icon>
                </v-btn>

                <v-btn text color="grey">
                    <span>Sign out</span>
                    <v-icon right>exit_to_app</v-icon>
                </v-btn>

            </v-app-bar>

            <NavDraw :drawer="drawer" ></NavDraw>

        </nav>
        <v-container>

            <v-list >

                <v-list-item>
                    <v-list-item-content>                                
                        <v-btn color="primary"
                        @click="updateIssues()">
                           Update Issues
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>


                <v-list-item>

                    <v-list-item-content>                                
                        
                        <v-btn color="primary"
                        @click="updateIssueTypes()">
                           Update Issue Types
                        </v-btn>

                    </v-list-item-content>


                </v-list-item>

                <v-list-item>

                    <v-list-item-content>                                
                        
                        <v-btn color="primary"
                        @click="updateIssueSubTypes()">
                           Update Issue Sub Types
                        </v-btn>

                    </v-list-item-content>


                </v-list-item>

                <v-list-item>
                    <v-list-item-content>                                
                        <v-btn color="primary"
                        @click="updateIssueMaster()">
                           Update Issue Masater
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>                                
                        <v-btn color="primary"
                        @click="updateDiagnostics()">
                           Update Diagnostics
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>                                
                        <v-btn color="primary"
                        @click="updateDiagnosticTypes()">
                           Update Diagnostic Types
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>                                
                        <v-btn color="primary"
                        @click="updateAssignees()">
                           Update Assignees
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>                                
                        <v-btn color="primary"
                        @click="updateDepartments()">
                           Update Departments
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>                                
                        <v-btn color="primary"
                        @click="updateLocations()">
                           Update Locations
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>                                
                        <v-btn color="primary"
                        @click="updateSections()">
                           Update Sections
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>                                
                        <v-btn color="primary"
                        @click="updateSolutionMethods()">
                           Update Solution Methods
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>                                
                        <v-btn color="primary"
                        @click="updateSolutionTypes()">
                           Update Solution Types
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>                                
                        <v-btn color="primary"
                        @click="updateSolutions()">
                           Update Solutions
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>                                
                        <v-btn color="primary"
                        @click="updateUsers()">
                           Update Users
                        </v-btn>
                    </v-list-item-content>
                </v-list-item>

            </v-list>

        </v-container>


    </div>
</template>

<script>
import NavDraw from '@/components/NavDraw'
import {mapState, mapActions} from 'vuex'
const fb = require('../../firebaseConfig.js')

export default {
    components:{NavDraw},
    data(){
        return {
            drawer:false,

        }
    },
    computed:{
        ...mapState(['brands'])
    },
    methods:{
        ...mapActions(['']),
        refresh(){
            //this.$store.dispatch('VIDEOS_GET');
            //this.fetchPhotos();
            //console.log("this.photos-refresh",this.photos);
        },

        updateUsers(){

            fb.usersCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.usersCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },

        updateIssues(){

            fb.issuesCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.issuesCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },

        updateIssueTypes(){

            fb.issueTypesCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.issueTypesCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },
        updateIssueSubTypes(){

            fb.issueSubtypesCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.issueSubtypesCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },
        updateIssueMaster(){

            fb.issueMasterCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.issueMasterCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },
        updateDiagnostics(){

            fb.diagnosticsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.diagnosticsCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },
        updateDiagnosticTypes(){

            fb.diagnosticTypesCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.diagnosticTypesCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },
        updateAssignees(){

            fb.assigneesCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.assigneesCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },
        updateDepartments(){

            fb.departmentsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.departmentsCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },
        updateLocations(){

            fb.locationsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.locationsCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },
        updateSections(){

            fb.sectionsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.sectionsCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },
        updateSolutionMethods(){

            fb.solutionMethodsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.solutionMethodsCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },
        updateSolutionTypes(){

            fb.solutionTypesCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.solutionTypesCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },
        updateSolutions(){

            fb.solutionsCollection.get()
            .then(docs=>{
                docs.forEach(doc=>{
                    fb.solutionsCollection.doc(doc.id).update({
                        hdType:'IT'
                    })
                });
            })
        },
        
    },
    mounted(){
        console.log("Home mounted!");

        //this.fetchPhotos();
        //console.log("this.photos-mounted",this.photos);

    }
}
</script>

<style  scoped>

</style>